import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Permission.Save.IRequest;
type Response = Api.Core.Permission.Save.IResponse;
type Headers = Api.Core.Permission.Save.IHeaders;
const url = '/api/Management/Permission';
export default async function permissionSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
